// OWNER: Agent C. Shared skeleton blocks — every view gets a loading state
// that traces the eventual layout, never a bare spinner.
import type { CSSProperties } from "react";

function Block({ className = "", style }: { className?: string; style?: CSSProperties }) {
  return <div className={`animate-pulse rounded-md bg-kumo-fill ${className}`} style={style} />;
}

export function KpiSkeleton() {
  return (
    <div className="space-y-2">
      <Block className="h-4 w-24" />
      <Block className="h-10 w-48" />
    </div>
  );
}

export function TableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <Block key={i} className="h-11 w-full" />
      ))}
    </div>
  );
}

export function ChartSkeleton({ height = 320 }: { height?: number }) {
  return <Block className="w-full" style={{ height }} />;
}

export function CardSkeleton() {
  return (
    <div className="space-y-3 rounded-lg border border-kumo-hairline p-4">
      <Block className="h-4 w-32" />
      <Block className="h-8 w-40" />
      <Block className="h-3 w-full" />
    </div>
  );
}
